import React from "react";
import { useLocation } from "react-router-dom";
import { IconRotateClockwise } from "@tabler/icons-react";
/** Vídeo de contexto esc. 3 — sustituir por el asset definitivo cuando esté listo. */
import contextVideoMp4 from "../../assets/videos/video-sc3-ct1.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { useVideoWithSound } from "../../hooks/useVideoWithSound";
import { useVideoContinueGate } from "../../hooks/useVideoContinueGate";
import "../StartGame.css";
import "../Scenario1/Scenario1Intro.css";
import Scenario2NextCta from "../Scenario2/Scenario2NextCta";
import "./Scenario3.css";

export default function Scenario3Context1() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);
	const { videoRef, canPlayWithSound } = useVideoWithSound({
		autoPlay: true,
		volume: 1.0,
	});
	const canContinue = useVideoContinueGate(videoRef);

	const handleReplayFromStart = () => {
		const el = videoRef.current;
		if (!el) return;
		el.currentTime = 0;
		el.play().catch(() => {});
	};

	return (
		<>
			<div className="s1-intro-page start-game-page--welcome sc3-context1-intro">
				<div className="s1-intro-inner">
					<span className="start-game-badge s1-intro-badge">
						<span className="start-game-badge-dot" aria-hidden />
						Escenario 2 · Evolución
					</span>

					<div className="s1-intro-video-frame">
						<video
							ref={videoRef}
							autoPlay
							muted={!canPlayWithSound}
							playsInline
							preload="metadata"
							aria-label="Vídeo de contexto"
						>
							<source src={contextVideoMp4} type="video/mp4" />
						</video>
					</div>

					<div className="s1-intro-footer">
						<button
							type="button"
							className="s1-intro-replay s1-intro-replay--icon"
							aria-label="Volver a reproducir el vídeo desde el principio"
							onClick={(e) => {
								e.preventDefault();
								handleReplayFromStart();
							}}
						>
							<IconRotateClockwise size={22} stroke={1.75} aria-hidden />
						</button>
						<Scenario2NextCta
							navigateTo={ROUTES.SCENARIO3_QUIZ1}
							activeScenario={activeScenario}
							className="s1-intro-cta"
							label="Continuar"
							canContinue={canContinue}
							lockedTitle="Espera a que el vídeo comience"
						/>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</>
	);
}
